import {useTranslation} from 'react-i18next';
import {useGetCompanies} from 'hooks/swr';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {MenuItem, TextField} from '@mui/material';

type CompanySelectorProps = {
  planId: string;
  companyId: string;
  setCompanyId: (companyId: string) => void;
  excludeCompanyIds?: string[];
  disabledCompanyIds?: string[];
} & React.ComponentProps<typeof TextField>;

export const CompanySelector = ({
  planId,
  companyId,
  setCompanyId,
  excludeCompanyIds,
  disabledCompanyIds,
  ...other
}: CompanySelectorProps) => {
  const {t} = useTranslation('common');
  const {ownership: ownershipEnabled} = useFlags();
  const {data: companies} = useGetCompanies({resourceId: ownershipEnabled ? planId : undefined});

  if (!ownershipEnabled) {
    return null;
  }

  const filteredCompanies = companies?.filter((company) => !excludeCompanyIds?.includes(company.id));

  return (
    <TextField
      select={filteredCompanies && filteredCompanies.length > 0}
      data-testid={'company-menu-selector'}
      value={companyId}
      onChange={(event) => {
        const companyId = event.target.value;
        setCompanyId(companyId);
      }}
      label={t('owner')}
      {...other}
    >
      {filteredCompanies?.map((company) => (
        <MenuItem key={company.id} value={company.id} disabled={disabledCompanyIds?.includes(company.id) ?? false}>
          {company.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
